/**
 * MC Gallery Dots — puces de la galerie produit (mobile), calage sezane.com.
 *
 * Sézane n'affiche pas une puce par image : une fenêtre glissante montre au
 * plus 5 puces à taille pleine, encadrées de deux puces réduites (66% puis 33%)
 * qui apparaissent et disparaissent au fil du défilement. Avec 20 images on voit
 * donc 9 puces au maximum, pas 20.
 *
 * Relevé sur sezane.com : puce de 8px, 16px de pas, blanche, opacité 0.4 et 1
 * pour l'image courante.
 *
 * Centrage : la fenêtre n'est PAS obtenue en fixant une largeur sur la liste.
 * Une première version le faisait et se décentrait dès que Splide reconstruisait
 * sa pagination : la largeur explicite disparaissait, `left: 50%` combiné au
 * `right: 0` de Splide donnait une boîte large de la moitié du conteneur, et le
 * `translateX(-50%)` décalait d'autant — les puces partaient à gauche.
 * Ici la liste occupe toute la largeur et centre ses puces en flex ; les puces
 * hors fenêtre sont simplement repliées (flex-basis: 0, animé). Le centrage est
 * donc vrai par construction, quoi que fasse Splide.
 *
 * Exposé en global parce que c'est le script de la section (snippet
 * mm-product-medias) qui possède l'instance Splide et appelle cette fonction à
 * chaque changement de vue.
 */
(function () {
	'use strict';

	var MAIN = 5; /* puces à taille pleine */
	var EDGE = 2; /* puces réduites de chaque côté */
	var OUT = 'mc-dot-out';

	function scaleFor(index, firstMain, lastMain) {
		if (index >= firstMain && index <= lastMain) return 1;
		if (index === firstMain - 1 || index === lastMain + 1) return 0.66;
		if (index === firstMain - 2 || index === lastMain + 2) return 0.33;
		return 0;
	}

	window.mcGalleryDots = function (pagination, activeIndex) {
		if (!pagination) return;

		var items = Array.prototype.slice.call(pagination.children);
		var total = items.length;
		if (!total) return;

		pagination.classList.add('mc-dots');

		var active = Math.max(0, Math.min(activeIndex || 0, total - 1));

		/* Peu d'images : on les montre toutes, sans réduction — c'est aussi ce
		   que fait la référence quand la série tient dans la fenêtre. */
		if (total <= MAIN) {
			items.forEach(function (li) {
				li.classList.remove(OUT);
				if (li.firstElementChild) li.firstElementChild.style.setProperty('--mc-dot-scale', '1');
			});
			return;
		}

		var firstMain = Math.min(Math.max(active - Math.floor(MAIN / 2), 0), total - MAIN);
		var lastMain = firstMain + MAIN - 1;

		items.forEach(function (li, i) {
			var scale = scaleFor(i, firstMain, lastMain);
			li.classList.toggle(OUT, scale === 0);
			if (li.firstElementChild) li.firstElementChild.style.setProperty('--mc-dot-scale', String(scale));
		});
	};
})();
